import * as api from '../../services/item/apiMatrixAttribute';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

export function* deleteMatrixAttributeSaga(feathersApp) {
  yield takeEvery('DELETE_MATRIX_ATTRIBUTE', callDeleteMatrixAttribute, feathersApp);
}

export function* deleteMatrixAttributeFromListSaga(feathersApp) {
  yield takeEvery('DELETE_MATRIX_ATTRIBUTE_FROM_LIST', callDeleteMatrixAttributeFromList, feathersApp);
}

export function* fetchListMatrixAttributeSaga(feathersApp) {
  yield takeLatest('FETCH_LIST_MATRIX_ATTRIBUTE', callFetchListMatrixAttribute, feathersApp);
}

export function* fetchMatrixAttributeForEditSaga(feathersApp) {
  yield takeEvery('FETCH_MATRIX_ATTRIBUTE_FOR_EDIT', callFetchMatrixAttributeForEdit, feathersApp);
}

export function* saveMatrixAttributeSaga(feathersApp) {
  yield takeEvery("SAVE_MATRIX_ATTRIBUTE", callSaveMatrixAttribute, feathersApp);
}

function* callFetchListMatrixAttribute(feathersApp, action) {
    const { silent, filters } = action;
    yield common.showProgressListTable(silent);
    try {
        const dataParams = { 
          filters, 
          doc_type: 'item_matrix_attribute',
        };
        const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
        yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
    } catch (error) {
      yield common.showErrorListTable(error);
    }
}

function* callDeleteMatrixAttributeFromList(feathersApp, action) {
  yield deleteMatrixAttribute(feathersApp, action);
  yield delay(2000);
  yield callFetchListMatrixAttribute(feathersApp, { silent: true });
}


function* callDeleteMatrixAttribute(feathersApp, action) {
  const result = yield deleteMatrixAttribute(feathersApp, action);
  yield delay(2000);
  if(result) {
    browserHistory.push('/admin/matrix/definition');
  }
}


function* deleteMatrixAttribute(feathersApp, action) {
    yield put({ type: 'DELETE_RECORD_INPROGRESS' });
    try {
        const { id } = action;
        let result = null;
        if(id) {
            const state = yield select();
            const { tenant, user } = state;
            const params = { tenant, user, id };
            result = yield call(api.deleteMatrixAttribute, feathersApp, params);
            yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.ITEM_MATRIX_ATTRIBUTE }});
            //yield callFetchListMatrixAttribute(feathersApp, { silent: true });
        }
        return result;
    } catch (error) {
        yield put({ type: 'DELETE_RECORD_ERROR', error })
    }
}


function* callSaveMatrixAttribute(feathersApp, action) {
  const { tenant, user, silent } = yield select();
  const data = {...action.data};
  if (data) {
    try {
      yield common.showProgressSaveRecord(silent);
      let result = yield call(api.saveMatrixAttribute, feathersApp, {
        tenant,
        user,
        data: action.data
      });
      yield callFetchMatrixAttributeForEdit(feathersApp, { id: result.id, silent: true });
      browserHistory.push(`/admin/matrix/definition/edit/${result.id}`);
      yield common.doneSaveRecord(result, 'Matrix attribute was saved');
    } catch (error) {
      yield common.showErrorSaveRecord(error);
    }
  }
}

function* callFetchMatrixAttributeForEdit(feathersApp, action) {
  const { tenant, user } = yield select();
  const { id, silent } = action;
  try {
    if(id) {
      yield common.showProgressDataById(silent);
      const fetchParams = { tenant, user, id };
      const doc = yield call(api.fetchMatrixAttributeById, feathersApp, fetchParams);
      //const parentItemsWithMatrixDef = yield call(api.fetchParentItemsMatrixDef, feathersApp, fetchParams);
      // if(parentItemsWithMatrixDef.docs.length > 0) {
      //   doc.parent_items = parentItemsWithMatrixDef.docs;
      // } else {
      //   doc.parent_items = [];
      // }
      yield common.doneDataById(doc);
    }
  } catch (error) {
    yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
  }
}